import {BaseApiResponseModel} from "../../infrastructure/models/base-api-response-model";
import {LineupsMemberApiModel} from "../yard/lineups/lineups-member/lineups-member-api-model";
import {PartialGameApiModel} from "../partial-game/models/partial-game-api-model";
import {CountryApiModel} from "../common/country/models/country-api-model";
import {CompetitionApiModel} from "../common/competition/models/competition-api-model";
import {CompetitorApiModel} from "../common/competitor/models/competitor-api-model";
import {SportApiModel} from "../sports/models/sport-api-model";
import {StatsCategoryApiModel} from "../yard/lineups/statsCategory/stats-category.api-model";
import type {ChartEventsApiModel} from "../full-game/models/chart-events/chart-events.api-model";


export class AthleteGameLineupsResponseApiModel extends BaseApiResponseModel {
  members: Array<LineupsMemberApiModel>;
  games: Array<PartialGameApiModel>;
  countries: Array<CountryApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorApiModel>;
  sports: Array<SportApiModel>
  statsCategories: Array<StatsCategoryApiModel>
  chartEvents: ChartEventsApiModel;

  constructor(model: AthleteGameLineupsResponseApiModel) {
    super(model);

    this.members = model.members;
    this.games = model.games;
    this.countries = model.countries;
    this.competitions = model.competitions;
    this.competitors = model.competitors;
    this.sports = model.sports;
    this.statsCategories = model.statsCategories;
    this.chartEvents = model.chartEvents;
  }
}
